var _style, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSofthubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1479.5306,
    y1: -21.3749,
    x2: -1478.7671,
    y2: -21.3749,
    gradientTransform: "matrix(253.9736 -280.3605 280.3605 253.9736 381864.375 -409006.4063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.7,193.1v47.5h43.3c7.3,0,13.4-6,13.4-13.4v-89.7c0-7.3-6-13.4-13.4-13.4h-89.7c-7.3,0-13.4,6-13.4,13.4 v42.7h46.9C272.9,180.3,278.7,186,278.7,193.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1479.5306,
    y1: -21.3719,
    x2: -1478.7671,
    y2: -21.3719,
    gradientTransform: "matrix(253.9736 -280.3605 280.3605 253.9736 381860.9375 -409009.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.9,273.9h67.9c7.1,0,12.8-5.8,12.8-12.8v-20.4h-46.4c-7.3,0-13.4-6-13.4-13.4v-46.9h-21 c-7.1,0-12.8,5.8-12.8,12.8V261C185.1,268.1,190.8,273.9,197.9,273.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1479.3616,
    y1: -23.0169,
    x2: -1478.5975,
    y2: -23.0169,
    gradientTransform: "matrix(499.9073 -212.6229 212.6229 499.9073 744432.9375 -302622.6563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBFC7"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.1,267.3c-1.3,0-2.4,1-2.4,2.4v25.7c0,1.3,1,2.4,2.4,2.4h25.7c1.3,0,2.4-1,2.4-2.4v-25.7 c0-1.3-1-2.4-2.4-2.4C324.8,267.3,299.1,267.3,299.1,267.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -1480.5275,
    y1: -23.4082,
    x2: -1479.7638,
    y2: -23.4082,
    gradientTransform: "matrix(913.7004 -640.8593 640.8593 913.7004 1367399.125 -926887.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FBFC7"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M196.4,160.9c1.3,0,2.4-1,2.4-2.4v-17.3c0-1.3-1-2.4-2.4-2.4h-17.3c-1.3,0-2.4,1-2.4,2.4v17.3 c0,1.3,1,2.4,2.4,2.4H196.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.0481,
    y1: 316.3849,
    x2: 399.0659,
    y2: 49.3048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.9,383.2c-6.3,0-10.9-2.6-14.8-6.5l-3.3,4c4.5,4.5,10.4,7.1,17.8,7.1c10.5,0,15.8-5.8,15.8-12.9 c0-7.9-6.1-11-14.8-13c-7.6-1.9-12.2-3.5-12.2-8.2c0-4.1,4-7.8,9.7-7.8c4.8,0,9.2,2.1,12.9,5.8l3.1-4c-4.1-3.8-9.2-6.4-15.8-6.4 c-8.7,0-15,5.6-15,12.8c0,7.8,5.6,10.7,14.8,12.7c7.9,1.9,12.2,3.8,12.2,8.5C118.4,379.4,114.7,383.2,107.9,383.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.6575,
    y1: 340.9955,
    x2: 425.6753,
    y2: 73.9153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.8,364.5c0-12.7-10.5-23.2-22.9-23.2s-23.1,10.7-23.1,23.2c0,12.7,10.7,23.3,23.1,23.3 C169.3,387.8,179.8,377.2,179.8,364.5z M138.9,364.5c0-10,8.2-18.6,17.9-18.6c9.7,0,17.8,8.5,17.8,18.6c0,10-8.2,18.6-17.8,18.6 C147.1,383.2,138.9,374.7,138.9,364.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.2803,
    y1: 360.994,
    x2: 447.2981,
    y2: 93.9139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "224,347 224,342.1 191.6,342.1 191.6,387.1 196.9,387.1 196.9,366.7 221.2,366.7 221.2,361.8  196.9,361.8 196.9,347  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.939,
    y1: 383.8004,
    x2: 471.9568,
    y2: 116.7203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "252.8,387.1 252.8,347 268,347 268,342.1 232.6,342.1 232.6,347 247.8,347 247.8,387.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.0124,
    y1: 411.6148,
    x2: 502.0302,
    y2: 144.5347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "278.6,342.1 278.6,387.1 288.3,387.1 288.3,368.5 308.9,368.5 308.9,387.1 318.4,387.1 318.4,342.1  308.9,342.1 308.9,359.8 288.3,359.8 288.3,342.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.4732,
    y1: 435.163,
    x2: 527.491,
    y2: 168.0829
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M330.5,342.1v25.6c0,11.9,8.4,20.2,20.3,20.2s20.3-8.4,20.3-20.2v-25.6h-9.7v25.2c0,6.9-4.5,11.9-10.7,11.9 c-6.3,0-10.8-4.9-10.8-11.9v-25.2H330.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.3719,
    y1: 461.891,
    x2: 556.3897,
    y2: 194.8109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7215,
    style: {
      stopColor: "#537CBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#69C0B9"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M413.9,363.4c4-2.1,6.3-5.4,6.3-10c0-6.5-5.5-11.3-13.7-11.3h-22.8v45h23.7c8.5,0,14.8-5,14.8-12.2 C422.1,369.9,419.1,365.8,413.9,363.4z M393.4,350.4h10.8c3.6,0,6.1,2.1,6.1,4.9c0,2.9-2.5,5-6.1,5h-10.8V350.4z M405.7,378.8 h-12.3v-11h12.3c3.9,0,6.6,2.3,6.6,5.5S409.5,378.8,405.7,378.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofthubLogo);
export default __webpack_public_path__ + "static/media/softhub-logo.eb5d74ccc4e2a4bec1b1a8cdb8cb32a1.svg";
export { ForwardRef as ReactComponent };